import { Link } from "react-router";

import { Column, Row, Text } from "@/components";
import { LeaderboardCrystalDrop } from "@/components/leaderboard/LeaderboardCrystalDrop";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { liquidity } from "@/lib/liquidity";

import type { LeaderboardLiquidJob } from "@/types";

// Crystal drop + count beside a staffer's name when their board holds liquid
// jobs; hovering lists them. Nothing renders for a board with none.
export const LeaderboardLiquidJobs = ({
  liquidJobs,
}: {
  liquidJobs: LeaderboardLiquidJob[];
}) => {
  /* Render */
  const render = () => {
    if (liquidJobs.length === 0) return null;

    return (
      <Tooltip delayDuration={150}>
        <TooltipTrigger asChild>
          <Row className="shrink-0 cursor-default items-start">
            <LeaderboardCrystalDrop />
            {/* Pulled back over the drop's empty top-right corner so the
                  count tucks against the tip, superscript-style */}
            <Text className="leaderboard-crystal-count -ml-1 -mt-1 text-[10px] font-semibold tabular-nums leading-none">
              {liquidJobs.length.toLocaleString()}
            </Text>
          </Row>
        </TooltipTrigger>
        <TooltipContent side="top" className="w-72 p-0">
          <Column>
            <Text className="border-b border-slate-100 px-3 py-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
              Liquid jobs on board
            </Text>
            <Column className="max-h-72 gap-2 overflow-y-auto p-3">
              {liquidJobs.map((job) => (
                <Link
                  key={job.jobId}
                  to={`/companies/${job.companyId}/jobs/${job.jobId}`}
                >
                  <Row className="items-center justify-between gap-3">
                    <Column className="min-w-0 gap-0.5">
                      <Text className="truncate text-xs font-semibold leading-none text-slate-900">
                        {job.title}
                      </Text>
                      <Text className="truncate text-[11px] font-normal leading-none text-slate-500">
                        {job.companyName}
                      </Text>
                    </Column>
                    <Text className="shrink-0 text-[11px] font-medium leading-none text-sky-700">
                      {liquidity.label(job.liquidity)}
                    </Text>
                  </Row>
                </Link>
              ))}
            </Column>
          </Column>
        </TooltipContent>
      </Tooltip>
    );
  };

  return render();
};
